import { Text, type TextProps } from '@chakra-ui/react';
import type { FC } from 'react';

const FaceliftText: FC<TextProps> = ({ children, ...rest }) => {
	return <Text {...rest}>{children}</Text>;
};

export default FaceliftText;
